import React, { useState, useEffect, useRef } from "react";
import { CreditCard, MoreVertical } from "lucide-react";
import { Eye } from "lucide-react";
import Modal from "react-modal";
import FeeSlip from "../../modals/parents/FeeSlip";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    border: "none",
  },
};

const FeesTable = ({ headings, data }) => {
  const [openIndexes, setOpenIndexes] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const { t, i18n } = useTranslation();
  const toggleDropdown = (index) => {
    setOpenIndexes((prevIndexes) => {
      if (prevIndexes.includes(index)) {
        return prevIndexes.filter((i) => i !== index);
      } else {
        return [index];
      }
    });
  };

  function closeModal() {
    setModalIsOpen(false);
  }

  const closeDropdown = (e) => {
    const clickedInsideDropdown = openIndexes.some(
      (index) => e.target.closest(`#dropdownMenu-${index}`) !== null
    );
    if (!clickedInsideDropdown) {
      setOpenIndexes([]);
    }
  };

  useEffect(() => {
    document.addEventListener("click", closeDropdown);
    return () => {
      document.removeEventListener("click", closeDropdown);
    };
  }, [openIndexes]);

  const items = [
    {
      label: "View Slip",
      icon: <Eye style={{ height: "30px", width: "30px;", color: "black" }} />,
    },
    {
      label: "Pay Now",
      icon: <CreditCard style={{ height: "30px", width: "30px;" }} />,
    },
  ];

  const handleClick = (label, item) => {
    if (label === "View Slip") {
      setSelectedItem(item);
      setModalIsOpen(true);
    }
  };

  const formatEnrollmentNo = (enrollmentNo) => {
    if (enrollmentNo.length > 7) {
      return `${enrollmentNo.slice(0, 5)}...${enrollmentNo.slice(-2)}`;
    }
    return enrollmentNo;
  };

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <FeeSlip onRequestClose={closeModal} selectedItem={selectedItem} />
      </Modal>
      <div className="container-table100">
        <div className="wrap-table100">
          <div className="table100 ver5 m-b-110">
            <div className="table100-head">
              <table>
                <thead>
                  <tr className="row100 head">
                    {headings.map((head, index) => (
                      <th
                        className={`cell100 column${index + 1} ${
                          index === headings.length - 1 && "text-align-end"
                        }`}
                        key={index}
                      >
                        {head}
                      </th>
                    ))}
                  </tr>
                </thead>
              </table>
            </div>

            <div className="table100-body">
              {data && data.length > 0 ? (
                <table>
                  <tbody>
                    {data.map((item, index) => (
                      <tr className="row100 body " key={index}>
                        <td className={`cell100 column1`}>
                          {formatEnrollmentNo(item.enrollmentNo)}
                        </td>
                        <td className={`cell100 column2`}>{new Date(item.feeBill.dueDate).toLocaleDateString()}</td>
                        <td className={`cell100 column3`}>{item.amountPaid.toFixed(2)}</td>
                        <td className={`cell100 column4`}>{item.feeBill.discountAmount.toFixed(2)}</td>
                        <td className={`cell100 column5`}>{item.feeBill.totalFee.toFixed(2)}</td>
                        <td className={`cell100 column6`}>{item.feeBill.status}</td>
                        <td className={`cell100 column7`}>
                          <div className="dropdown d-flex justify-content-end">
                            <div
                              className="iconWrapper "
                              type="button"
                              onClick={() => toggleDropdown(index)}
                              id={`dropdownMenu-${index}`}
                            >
                              <MoreVertical />
                            </div>
                            <ul
                              className={`dropdown-menu gradeTableDropdown p-0 py-1 ${
                                openIndexes.includes(index) ? "show" : ""
                              }`}
                            >
                              {items.map((actionItem, i) => (
                                <li
                                  key={i}
                                  className="px-2 rounded"
                                  onClick={() => handleClick(actionItem.label, item)}
                                >
                                  <Link
                                    className="dropdown-item  optionLists align-items-center rounded  mt-1 d-flex justify-content-between"
                                    href="#"
                                  >
                                    <span
                                      className="h6 p-0 m-0"
                                      style={{ color: "black" }}
                                    >
                                      {actionItem.label}
                                    </span>
                                    {actionItem.icon}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="text-center p-4">
                  <p>{t('Nodataavailable')}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FeesTable;
